// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"067e64a2","492":"8127ffc5","887":"006fea0c"}[chunkId] + ".chunk.js";
};